import { Relationship } from "@covertree/agent-portal-graphql";

export const mapRelationship = (value?: Relationship): string => {
  if (!value) return "N/A";
  switch (value) {
    case Relationship.OtherFamily:
      return "Other Family";
    case Relationship.Owner:
      return "Second Owner";
    default:
      return value;
  }
};
